import { put } from "redux-saga/effects";
import { serverRequest } from "../../actions";

export function* saveForm3(action) {
  var payload = {
    action: "portal/saveFormData3",
    id: action.id,
    key: action.key,
    value: action.value,
    context: action.context,
    clientStatus: action.clientStatus,
  };

  // 2021-02 removed validation

  // const formData = yield select(getForm3Data)
  // const formNodes = yield select(getForm3Nodes)
  // const validations = yield select(getForm3Validations)
  // const node = formNodes[action.key]

  // if( ! node ) {
  //   return null
  // }

  //yield validateField({node,validations,value:action.value,key:action.key})

  yield put(serverRequest(payload));
}

export default saveForm3;
